import Swal from "sweetalert2";

export function showSwalQuestion(title) {
  return Swal.fire({
    title,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "بله",
    cancelButtonText: "خیر",
  });
}
export function showSwalError(error) {
  return Swal.fire({
    title: error,
    icon: "error",
    showConfirmButton: false,
    timer: 1500,
  });
}
export function showSwalSuccess(title) {
  return Swal.fire({
    title,
    icon: "success",
    showConfirmButton: false,
    timer: 1500,
  });
}
